'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./ToolSeparator.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var ToolSeparator = function ToolSeparator() {
    return _react2.default.createElement('div', { className: 'ToolSeparator' });
};

// Styles


ToolSeparator.propTypes = {};

exports.default = ToolSeparator;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/ToolSeparator.js
// module id = 787
// module chunks = 0